// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"3407941b","124":"c595152a","256":"d4e9bc44","290":"96400509","330":"d514834f","443":"b265bb68","787":"b236053b","932":"a7aff045"}[chunkId] + ".chunk.js";
};